import { useState, useEffect } from "react";
import axios from "axios";
import styles from "../Components/ProductList.module.css"
import Api from "../api/ecomApi";
const AddressUpdate = () => {
  let loggedInId = localStorage.getItem('user_id');
  //const [addressDetails, setAddressDetails] = useState('');
  const [address, setAddress] = useState('');
  const [city, setCity] = useState('');
  const [pincode, setPincode] = useState('');
  const [mobileno, setMobileno] = useState('');
  useEffect(() => {    
      Api.get(`customer-details/${loggedInId}/`)
        .then((response) => {
          console.log(response.data[0])
          //setAddressDetails(response.data[0]);
          setAddress(response.data[0].address);
          setCity(response.data[0].city);
          setPincode(response.data[0].pin_code);
          setMobileno(response.data[0].mobile_no);
        })
      .catch((error) => {
        console.log(`Hello${error}`);
      });
    }, []);
    //create here for submit method
    const submit = async (e) => { 
        console.log('Hello');
    e.preventDefault();
    const user = {      
      address: address,
      userId: localStorage.getItem('user_id'),
      city: city,
      pincode: pincode,
      mobileno : mobileno
    };
    //create her post request
    //const { data } = await
    axios.post(`${global.config.live_url}/api/address-change/`, user,{mode: 'no-cors', headers: { 'Content-Type': 'application/json' }, withCredentials: true });      
    window.location.href = '/place-order';
   
  }
    return <><div className={`col-sm-12 ${styles.mainContainer}`}>
          <div className="container">
            <form onSubmit={submit}>              
              <div className="mb-3 row">
              <label for="addressTextarea1" className="col-sm-2 col-form-label">Address</label>
              <div className="col-sm-10">
                <textarea className="form-control" id="addressTextarea1" rows="3" required
                    value={address}
                    onChange={(e) => setAddress(e.target.value)}></textarea>
              </div>
          </div>
          <div className="mb-3 row">
                <label for="selectCityId" className="col-sm-2 col-form-label">
                  Select your City/Town
                </label>
                <div className="col-sm-10">
                  <select className="form-control" id="selectCityId" value={city} required onChange={(e) => setCity(e.target.value)}>
                <option value="">select city/town</option>
                <option value="Faridabad">Faridabad</option>              
                
                  </select>
                </div>
          </div>
          <div className="mb-3 row">
                <label for="inputPinCodeId" className="col-sm-2 col-form-label">
                  Pin Code
                </label>
                <div className="col-sm-10">
                  <input
                    type="number"
                    className="form-control"
                    id="inputPinCodeId"                    
                    maxlength="6"
                    required
                    value={pincode}
                    onChange={(e) => setPincode(e.target.value)}
                  />
                </div>
          </div>
          <div className="mb-3 row">
                <label for="inputMobileNo" className="col-sm-2 col-form-label">
                  Mobile no
                </label>
                <div className="col-sm-10">
                  <input
                    type="number"
                    className="form-control"
                    id="inputMobileNo"
                    required
                    value={mobileno}
                    onChange={(e) => setMobileno(e.target.value)}
                  />
                </div>
              </div>
              <div className="mb-3 row">
                <label
                  for="textareaAddress"
                  className="col-sm-2 col-form-label"
                ></label>
                <div className="col-sm-10">
                  <button type="submit" className="btn btn-info">
                    Address change
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div></>
}
export default AddressUpdate